var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPropertyIconOther(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    transform: "translate(528 773)",
    fill: "red"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-528 -773)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.53,2.508a2.191,2.191,0,0,0-1.358.469h0L4.2,6.9A3.139,3.139,0,0,0,3,9.362v7.567a1.474,1.474,0,0,0,1.464,1.464H8.519a.627.627,0,0,0,.258,0h3.507a.627.627,0,0,0,.258,0H16.6a1.474,1.474,0,0,0,1.464-1.464V9.362a3.139,3.139,0,0,0-1.2-2.464h0l-4.976-3.92A2.191,2.191,0,0,0,10.53,2.508Zm0,1.252a.939.939,0,0,1,.582.2l4.976,3.92a1.881,1.881,0,0,1,.717,1.479v7.567a.2.2,0,0,1-.209.209H13.04v-1.25h2.3a.628.628,0,1,0,0-1.255h-2.3V13.378h2.3a.628.628,0,1,0,0-1.255h-2.3V10.868h2.3a.628.628,0,1,0,0-1.255H5.719a.628.628,0,1,0,0,1.255h2.3v1.255h-2.3a.628.628,0,1,0,0,1.255h2.3v1.255h-2.3a.628.628,0,1,0,0,1.255h2.3v1.25H4.464a.2.2,0,0,1-.209-.209V9.362a1.881,1.881,0,0,1,.717-1.479l4.976-3.92A.939.939,0,0,1,10.53,3.76ZM7.393,7.1a.628.628,0,1,0,0,1.255h6.275a.628.628,0,1,0,0-1.255Zm1.883,3.765h2.51v1.78a.628.628,0,0,0,0,.2v2.307a.628.628,0,0,0,0,.2v1.777H9.275V15.364a.629.629,0,0,0,0-.2V12.854a.629.629,0,0,0,0-.2Z",
    transform: "translate(527.47 772.542)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropertyIconOther);
export default __webpack_public_path__ + "static/media/property-icon-other.f0130cb85aba487ef4416c760bebd120.svg";
export { ForwardRef as ReactComponent };